import React, { Component } from 'react';
import { connect } from 'react-redux'
import ReactGA from 'react-ga';
import { Row, Col } from 'reactstrap';

import intro_tt from '../../../assets/img/infographic.svg'
import { Disclaimers } from '../common';
import { trackingActions } from '../../../core/tracking';

class Start extends Component {

  handleClick = (event) => {
    const { hanndleNextQuestion } = this.props;

    ReactGA.event({
      category: 'Thinking Talent',
      action: 'Creation started'
    })
    this.props.saveTrackingEvent({category: 'Thinking Talent', action: 'Creation started'})

    hanndleNextQuestion( 'questions' );
  }

  render() {
    return (
      <>
      <Row>
        <Col lg={{ size: 7 }} className='mx-auto'>
          <div className='pt-md-3 px-md-3 rounded border-md'>
            <div className='mb-3'>
              <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Thinking Talents</h1>
              <p className='mb-3'><strong>Thinking Talents are the natural ways you approach a problem that actually give you energy.</strong></p>
              <p className='mb-3'>These are innate ways you have used to think about problems since you were young, and consequently, they have created deep pathways in your brain. Thinking Talents are different from skills, which can be learned, but can also be depleting when overused.</p>
              <p className='mb-4'>Research with over 2 million people shows that each of us have between 5-8 of these talents. When used together, they create your natural capacity for excellence.</p>
              <img src={intro_tt} alt="Thinking Talents" className="img-fluid mx-auto d-block" />
            </div>

            <div className='rounded p-2 border border-ice-70 bg-ice-40 mb-4'>
              <p className='small'><strong>Ready?</strong> The quiz will describe 35 talents. Take your time answering <strong>Always, Sometimes</strong> or <strong>Never</strong> for each one.<br/>
              Your goal is to have 5-8 Always talents when finished and there is no way you can be wrong.</p>
              <p className='small mb-0'><i><strong>Remember:</strong> A talent is energizing and something <strong>you cannot help but do.</strong></i></p>
            </div>

            <p className='text-orange small mb-4'><i>Please note that answers are not saved until the assessment is completed. If you exit the assessment prior, you will need to retake it.</i></p>

            <button onClick={this.handleClick.bind(this)} className="btn btn-green-light btn-sm mx-auto px-3 d-block mb-5">
              <i className="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                      <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
                  </svg>
              </i>
              Start Assessment
            </button>

            <Disclaimers view="propiedad-intelectual" />
          </div>

        </Col>
      </Row>
      </>
    );
  }
}

const mapDispatchToProps = {
  saveTrackingEvent: trackingActions.saveTrackingEvent
}

export default connect(
  null,
  mapDispatchToProps
)(Start);
